import { FilterStage, StageParameters } from '@data/Simulations/pipeline/Stage';
import { SensorData } from 'Simulations/SensorPoint';

export interface RemoveSensorsByIdStageParameters extends StageParameters {
    sensorIds: Set<number>;
    isInverted: boolean;
}

class RemoveSensorsByIdStage extends FilterStage<RemoveSensorsByIdStageParameters> {
    protected override filter(sensorData: SensorData): boolean {
        const { sensorIds, isInverted } = this.getParams();
        const rawSensorIds = sensorIds as unknown;
        const normalizedSensorIds =
            rawSensorIds instanceof Set ? rawSensorIds : Array.isArray(rawSensorIds) ? new Set(rawSensorIds) : new Set<number>();
        const hasSensor = normalizedSensorIds.has(sensorData.getID());
        return isInverted ? hasSensor : !hasSensor;
    }
}

export default RemoveSensorsByIdStage;
